import React from 'react'
import { Header } from 'semantic-ui-react'

import '../css/user-card.css'

export default class UserCard extends React.Component {
  render () {
    const { name, display, year } = this.props
    return (
      <div className='user-card-contaier'>
        <div>
          <img
            src={display}
            alt={name}
            width='48'
            height='48'
            className='user-card-dp'
          />
        </div>
        <div className='user-card-detail'>
          <Header as='h4'>
            {name}
            <Header.Subheader>{year}</Header.Subheader>
          </Header>
        </div>
      </div>
    )
  }
}
